// extracted by mini-css-extract-plugin
export var faqSection = "styles-module__faqSection___KsMJq";